import { breakpoints } from "@brightagency/headstart-common";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import { lighten } from "polished";
import React from "react";
import styled from "styled-components";
import { zIndex } from "../../../../constants";
import { buttonResetStyles } from "../../../../utils";
import { colors } from "../../../../utils/colors";

const Button = styled.button`
    ${buttonResetStyles}
    width: 56px;
    height: 56px;
    background-color: ${colors.brandLight};
    border-radius: 50%;
    color: ${colors.brandDark};
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 0;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);

    z-index: ${zIndex.scrollToTop};

    &:hover {
        background-color: ${lighten(0.05, colors.brandLight)};
    }

    ${breakpoints.large} {
        right: 0;
        left: auto;
        transform: translateY(-50%);
    }

    svg {
        font-size: 32px;
    }
`;

export const ScrollToTop = () => {
    return (
        <Button
            onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }}
        >
            <ExpandLessRoundedIcon />
        </Button>
    );
};
